import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "CodeRidge - Leading Technology & Innovation Solutions | Software Development Company Hyderabad",
  description = "CodeRidge is a premier technology and innovation company in Hyderabad, India. We specialize in cutting-edge software development, web applications, mobile apps, cloud solutions, and EdTech platforms.",
  keywords = "technology solutions, innovation company, software development, web development, mobile app development, cloud solutions, EdTech, technology innovation, software company Hyderabad, digital transformation",
  image = "https://coderidge.in/sign-no-tagline-transparent-3000x3000.svg",
  url = "https://coderidge.in",
  type = "website"
}) => {
  const fullTitle = title.includes('CodeRidge') ? title : `${title} | CodeRidge`;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEO;










